// src/pages/LandingPage.js
import React from "react";
import { Link } from "react-router-dom";
// Removed bootstrap-icons CSS import from this file

export default function LandingPage() {
  const tiles = [
    { title: "Finance System", icon: "bi-cash-stack", route: "/finance/dashboard", gradient: "linear-gradient(to bottom, #ffffffff, #fcfcfcff)" },
    { title: "SIS", icon: "bi-mortarboard", route: "/sis/dashboard", gradient: "linear-gradient(to bottom, #ffffffff, #ffffffff)" },
    { title: "HR / Payroll", icon: "bi-people", route: "/hr/payroll", gradient: "linear-gradient(to bottom, #ffffffff, #ffffffff)" },
    { title: "Admin Panel", icon: "bi-gear", route: "/admin/dashboard", gradient: "linear-gradient(to bottom, #ffffffff, #ffffffff)" },
    { title: "Uniforms", icon: "bi-bag", route: "/uniforms/inventory", gradient: "linear-gradient(to bottom, #ffffffff, #ffffffff)" },
    { title: "Books", icon: "bi-book", route: "/books/inventory", gradient: "linear-gradient(to bottom, #ffffffff, #ffffffff)" },
    { title: "Student Portal", icon: "bi-person-badge", route: "/portal", gradient: "linear-gradient(to bottom, #ffffffff, #ffffffff)" },
    { title: "Login", icon: "bi-box-arrow-in-right", route: "/login", gradient: "linear-gradient(to bottom, #ffffffff, #ffffffff)" },
    { title: "Handbook (PDF)", icon: "bi-file-earmark-text", route: "/manual", gradient: "linear-gradient(to bottom, #ffffffff, #ffffffff)" },
  ];

  return (
    <div
      style={{
        background: "white",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        padding: "20px",
      }}
    >
      <div
       className="text-center p-6  mb-3"
        style={{
          width: "100%",
          maxWidth: "1200px",
          background: "linear-gradient(135deg, #1e88e5 0%, #42a5f5 40%, #90caf9 100%)",
          color: "#1b2430",
          fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
          padding: "40px 20px",
          borderRadius: "15px",
          textAlign: "center",
          marginBottom: "30px",
          boxShadow: "0px 4px 15px rgba(0,0,0,0.2)",
        }}
      >
        <img
          src="/vmsc_logo.png"
          alt="VMSC Logo"
          style={{
            width: "160px",
            height: "160px",
            objectFit: "cover",
            borderRadius: "15%",
            border: "4px solid #ffffff",
            marginBottom: "20px",
          }}
        />
        <h1 className="mt-3" style={{ color: "#ffffff", fontWeight: 800, letterSpacing: 0.6 }}>Village Montessori School and Colleges</h1>
        <p style={{ color: "#e3f2fd", fontSize: 18, marginBottom: 8 }}>Where quality education is at its best</p>
        <p style={{ color: "#e3f2fd", fontSize: 14, marginTop: 0 }}>VMS Guiding Light — Proverbs 22:6: Train up a child in the way he should go; when he is old he will not depart from it.</p>
        <hr className="thick-border"></hr>
        <br />

        {/* ===== Tiles Section ===== */}
    
        <div className="text-darkbrown row g-4 justify-content-center">
          {tiles.map((tile, index) => (
            <div className="col-6 col-md-3" key={index}>
              <Link to={tile.route} className="text-decoration-none">
                <div
                  className="tile-card"
                  style={{
                    background: "linear-gradient(180deg, #ffffff, #f6fbff)",
                    padding: "20px",
                    borderRadius: "12px",
                    boxShadow: "0px 6px 16px rgba(30, 136, 229, 0.12)",
                    transition: "transform 0.2s",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
                  onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                >
                  <i className={`bi ${tile.icon} display-5 mb-2`}></i>
                  <h5 className="text-darkblue" style={{ color: "#0d47a1" }}>{tile.title}</h5>
                </div>
              </Link>
            </div>
          ))}
      </div>

      </div>
      <footer style={{ width: "100%", maxWidth: "1200px", textAlign: "center", marginTop: "12px", padding: "16px 0", color: "#607d8b" }}>
        <div style={{ fontWeight: 600 }}>Village Montessori School Management System (VMSC‑SMS)</div>
        <div style={{ fontSize: 13 }}>© {new Date().getFullYear()} Village Montessori School • Proverbs 22:6</div>
      </footer>
    </div>
  );
}
